export default "__VITE_ASSET__c00faf6e__"